import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ControlEfectivoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }


  GetByDetalleCajaDiaria(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: control_efectivoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            control_efectivo {
              detalleCajaDiaria(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros{
                    rut_emisor
                    sucursal_codigo
                    folio
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    fecha_declaracion
                    banco_codigo
                    banco_nombre
                    monto
                    recorrido_codigo
                    numero_doc
                    tipo_pago_codigo
                    tipo_pago_nombre
                    existe_protesto
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.control_efectivo.detalleCajaDiaria
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByDetalleCajaDiariaExcelPDF(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: control_efectivoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            control_efectivo {
              detalleCajaDiaria(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros{
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.control_efectivo.detalleCajaDiaria
        callback({ mensajes, respuesta })
      }
    );
  }
}
